import { render } from "./Set.vue?vue&type=template&id=606d0234&scoped=true"
import script from "./Set.vue?vue&type=script&lang=js"
export * from "./Set.vue?vue&type=script&lang=js"

import "./Set.vue?vue&type=style&index=0&id=606d0234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606d0234"]])

export default __exports__